import { PrismButton } from "@prism-ui/react";

type Props = {
  error: string
  onRetry?: () => void
}
const ErrorMessage = ({error, onRetry}:Props) => (
  <div className="error-message" style={{paddingTop: "2em"}}>
    <h2>An unexpected error occurred:</h2>
    <h3>{error}</h3>
    {onRetry ? <PrismButton tone="primary" onPrismClick={onRetry}>Retry</PrismButton> : null}
  </div>
)

export default ErrorMessage
